<template>
  <svg
    :class="size"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_203_6)">
      <path
        d="M367.305 25.402C333.649 9.128 295.891 0 256.001 0C216.111 0 178.353 9.128 144.697 25.402L122.436 256L144.697 486.598C178.353 502.872 216.111 512 256.001 512C295.891 512 333.649 502.872 367.305 486.598L389.566 256L367.305 25.402Z"
        fill="#FFDA44"
      />
      <path
        d="M255.997 166.957L278.097 234.977H349.625L291.761 277.02L313.862 345.043L255.997 303.003L198.132 345.043L220.237 277.02L162.373 234.977H233.896L255.997 166.957Z"
        fill="#496E2D"
      />
      <path
        d="M144.696 25.4109C59.066 66.8179 0 154.507 0 256C0 357.493 59.066 445.182 144.696 486.589V25.4109Z"
        fill="#496E2D"
      />
      <path
        d="M367.305 25.4109V486.589C452.935 445.182 512.001 357.493 512.001 256C512.001 154.507 452.935 66.8179 367.305 25.4109Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_203_6">
        <rect width="512" height="512" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: 'h-5 w-5'
    }
  }
}
</script>
